import { useQuery } from "@tanstack/react-query";
import { VendorService } from "src/services";
import { Vendor } from "src/types";
import { queryKeys } from "src/constants";

const useVendorById = (vendorId?: string, vendorService?: VendorService) => {
  const enabled = Boolean(vendorId && vendorService);

  const queryResult = useQuery<Vendor, Error>({
    queryKey: queryKeys.vendorById(vendorId),
    queryFn: async () => {
      if (!vendorId || !vendorService) {
        throw new Error("Vendor identifier missing");
      }

      return await vendorService.getVendorById(vendorId);
    },
    enabled,
    staleTime: 5 * 60 * 1000
  });

  return {
    vendor: queryResult.data,
    error: queryResult.error,
    isLoading: queryResult.isLoading,
    isFetching: queryResult.isFetching,
    refetch: queryResult.refetch
  };
};

export { useVendorById };
